import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { ProductTracelogVm } from './product-tracelog.vm';
import { PageResponseVm } from 'api/core/page-response.vm';

export class GetProductTracelogsVm extends PageResponseVm<ProductTracelogVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ProductTracelogVm)
  @ValidateNested({ each: true })
  objects: ProductTracelogVm[];
}
